import { cn, ProductBadge } from '@yanolja-rnd/nol-design-system'

/**
 * 공통 > 뱃지 리스트(primary product badges)
 */
const PrimaryProductBadges = ({ badges }: { badges: string[] }) => {
  return (
    <div className={cn('flex flex-wrap gap-4 break-keep')}>
      {badges.map((badge, index) => (
        <ProductBadge key={index} type="filled_primary" size="medium" className="w-fit">
          {badge}
        </ProductBadge>
      ))}
    </div>
  )
}

export default PrimaryProductBadges
